import React from 'react';
import ReactDOM from 'react-dom';
import SubcribeAndSave from '../components/global/SubscribeAndSave';
import getCookie from '~/js/modules/get-cookie';

const footer = () => {
  const footerPopupBtn = document.querySelector('.js-chat-btn');
  const footerPopupBlock = document.querySelector('.js-chat-popup');
  const chatContainer = document.querySelector('.chat-options');

  const subAndSave = document.querySelector('#subscribe-and-save');
  const requestURI = window.beaches_app.requestURI;

  if(subAndSave) {
    ReactDOM.render(
      <SubcribeAndSave
        requestURI = {requestURI}
      />,
      subAndSave
    );
  }

  function ChatPopup(popupBtn, popupElem) {
    this.windowWidth = document.documentElement.clientWidth;

    this._events = () => {
      window.addEventListener('resize', () => {
        this.windowWidth = document.documentElement.clientWidth;
        popupElem.classList.remove('show');
      });

      if(this.windowWidth <= 1024) {
        popupBtn.addEventListener('click', e => {
          e.preventDefault();
          if (!popupElem.classList.contains('show')) {
            popupElem.classList.add('show');
          }
        });
      } else {
        popupBtn.addEventListener('mouseover', e => {
          e.preventDefault();
          if (!popupElem.classList.contains('show')) {
            popupElem.classList.add('show');
          }
        });
      }

      chatContainer.addEventListener('mouseleave', () => {
        if(this.windowWidth >= 1024) {
          popupElem.classList.remove('show');
        }
      });

      popupElem.querySelector('.js-chat-close').addEventListener('click', () => {
        popupElem.classList.remove('show');
      });

      $(document).mouseup( (e) => {
        const container = $('.js-chat-popup, .js-chat-btn');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          popupElem.classList.remove('show');
        }
      });

      document.addEventListener('touchend', (e) => {
        const container = $('.js-chat-popup, .js-chat-btn');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          popupElem.classList.remove('show');
        }
      });
    };

    this._init = () => {
      this._events();
    };
  }

  if (footerPopupBtn) {
    const popup = new ChatPopup(footerPopupBtn, footerPopupBlock);

    popup._init();
  }

  //  LANGUAGE
  let justEnteredHere = false;
  class ShowLanguagePanel {
    constructor(langBtnClass, langBlockClass) {
      this.langBtnClass = langBtnClass;
      this.langBlockClass = langBlockClass;
      this.langBtn = document.querySelector(`.${langBtnClass}`);
      this.langBlock = document.querySelector(`.${langBlockClass}`);
      this.btnIcon = this.langBtn.querySelector('i');
      this._events();
    }

    _events() {
      this.langBtn.addEventListener('click', () => {
        // e.preventDefault();
        this.langBlock.classList.toggle(`${this.langBlockClass}--show`);
        this.langBtn.focus();
        // if(window.innerWidth < 767) {
        if(this.langBlock.classList.contains(`${this.langBlockClass}--show`)) {
          this.langBtn.setAttribute('aria-expanded', 'true');
          justEnteredHere = true;
        }else {
          this.langBtn.setAttribute('aria-expanded', 'false');
        }
        this.btnIcon.classList.toggle('icon-close');
        this.btnIcon.classList.toggle('icon-globe');
        // }
      });

      window.addEventListener('resize', _globalUtils.debounce(() => {
        this.langBlock.classList.remove(`${this.langBlockClass}--show`);
        this.langBtn.setAttribute('aria-expanded', 'false');
        this.btnIcon.classList.remove('icon-close');
        this.btnIcon.classList.add('icon-globe');
      }, 200));

    }
  }

  document.body.addEventListener('click', e => {
    const langBtn = document.querySelector('.js-lang-btn');
    const countryButton = document.querySelector('.hm-country');

    if (document.body.contains(countryButton) && !justEnteredHere) {
      if(e.target !== langBtn && e.target !== document.querySelector('.js-lang-btn-turnoff')) {
        if($(e.target).closest('.ht-country-list')) {
          document.querySelector('.ht-country-list').classList.remove('ht-country-list--show');
          langBtn.setAttribute('aria-expanded', 'false');
          langBtn.querySelector('i').className = 'icon-globe';
        }
      }
    }
    justEnteredHere = false;
  });

  document.querySelector('.js-lang-btn') && new ShowLanguagePanel('js-lang-btn', 'ht-country-list');

  // Keyboard Accessibility
  const $languageButton = $('.js-lang-btn');
  const $languageList = document.querySelector('.js-lang-list');
  const $footerElements = $('.list-section .desktop-list');
  const $spanishHelpButton = $('#esp-chat');
  const $chatPopUp = document.querySelector('.js-chat-popup');
  const $chatPopUpPhone = document.querySelector('.js-chat-popup .phone-number');
  const hideLanguageListPopup = () => {
    $languageButton.attr('aria-expanded', 'false');
    $languageList.classList.remove('ht-country-list--show');
    $languageButton.find('i').removeClass('icon-close').addClass('icon-globe');
  };

  if ($languageButton) {
    $languageButton.on('keydown', (e) => {
      const { keyCode } = e.originalEvent;

      if (keyCode === 32 || keyCode === 13 ) {
        e.target.click();

        // $languageList.focus();
      }

      if (keyCode === 27) {
        e.target.setAttribute('aria-expanded', 'false');
        e.target.focus();
        hideLanguageListPopup();
      }
    });

    $footerElements.on('focus', 'li', () => {   
      if ($languageList.classList.contains('ht-country-list--show')) {
        $languageButton.attr('aria-expanded', 'false');
        hideLanguageListPopup();
      }
    });
  }

  if ($chatPopUp) {
    $spanishHelpButton.on('keydown', (e) => {
      if (window.innerWidth > 1024) {
        const { keyCode } = e.originalEvent;

        if (keyCode === 32 || keyCode === 13 ) {

          $chatPopUp.classList.add('show');
          // $chatPopUpPhone.focus();
        }

        if (keyCode === 27) {
          $chatPopUp.classList.remove('show');
        }
      }
    });

    $($chatPopUpPhone).on('blur', (e) => {
      $chatPopUp.classList.remove('show');
    });
  }

  //Add onClick to Your privacy Choices link
  const aboutLinks = document.querySelectorAll("[data-links='about-beaches'] li" );
  const isFromCalifornia = getCookie('isFromCalifornia') !== null && getCookie('isFromCalifornia') === 'true';
  
  for (const linkItem of aboutLinks) {
    const linkItemText = linkItem.innerText.toLowerCase();
    
    if (linkItemText === 'do not sell or share my personal data' && !isFromCalifornia) {
      linkItem.classList.add('hide-item');
    }

    if (linkItemText === 'your privacy choices' || (linkItemText === 'do not sell or share my personal data' && isFromCalifornia)) {
      // const link = linkItem.firstElementChild;
      //   link.addEventListener('click', e => {
      //   e.preventDefault();
      //   window.semaphore.push(['showPreferences']);
      // });

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const showCookiePreferences = urlParams.get('showCookiePreferences');

      if (showCookiePreferences) {
        link.click();
      }
    }
  }


};

export default footer;
